import { type Auth0ContextInterface, User } from '@auth0/auth0-react';
import { jwtDecode } from 'jwt-decode';

import { getOrganizations } from '@/providers/auth/get-organizations';

type AuthState =
  | { type: 'notAuthenticated' }
  | { type: 'authenticated'; organizations: string[] }
  | { type: 'orgAuthenticated' };

export async function stateFromAuth0(
  auth0: Auth0ContextInterface<User>,
): Promise<AuthState> {
  const { setOrganizations } = getOrganizations();
  if (!auth0.isAuthenticated || auth0.isLoading) {
    return { type: 'notAuthenticated' };
  }
  const accessToken = await auth0.getAccessTokenSilently();
  const decodedToken = jwtDecode<{ permissions: string[]; org_name?: string }>(
    accessToken,
  );
  if (!decodedToken.org_name) {
    const organizations = decodedToken.permissions
      .filter((org) => org.startsWith('tenant:'))
      .map((org) => org.replace('tenant:', ''));
    if (organizations.length === 0) {
      throw new Error('No organizations found');
    }
    setOrganizations(organizations);
    return { type: 'authenticated', organizations };
  }
  return { type: 'orgAuthenticated' };
}
